<template>
  <div id="contactus" class="c-content">
    <banner-general :content="banner"></banner-general>

    <div class="c-content__twoBlock c-standard">
      <div class="c-content__twoBlock--text">
        <img class='l-margin-bottom-5' :src="block.img" :alt="block.company">
        <h4>{{block.company}}</h4>
      </div>
      <div class="c-content__twoBlock--text">
        <h5 class='l-margin-bottom-20'>{{block.address}}</h5>
        <p>{{block.postcode}}</p>
        <p>{{block.phone}}</p>
        <!-- <p>{{block.facsimile}}</p> -->
        <p>{{block.email}}</p>
      </div>
    </div>

    <div class="c-map">
      <el-amap :center='mapData.center' :zoom='mapData.zoom' :lang='lang'>
        <el-amap-marker vid="component-marker" :position="mapData.center" :label="mapLabel">
          <!-- <img src="https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png" style="width: 19px; height: 33px; top: 0px; left: 0px;"> -->
        </el-amap-marker>
      </el-amap>

    </div>
  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import BannerGeneral from '../layout/bannerGeneral.vue'

  export default {
    name: 'contactus',
    components: {
      'banner-general': BannerGeneral
    },
    data(){
      return {
        contactus: {},
        banner: {
          type: '2',
          img: require('../../assets/img/banner_connect.jpg'),
          title: this.$t('contact_us.banner.title'),
          content: this.$t('contact_us.banner.content'),
        },
        block: {
          img: require('../../assets/img/logo_main_systec.svg'),
          company: this.$t('contact_us.text.company'),
          address: this.$t('contact_us.text.address'),
          postcode: this.$t('contact_us.text.postcode'),
          phone: this.$t('contact_us.text.phone'),
          facsimile: this.$t('contact_us.text.facsimile'),
          email: this.$t('contact_us.text.email'),
        },
        mapData: {
          center: ["117.122210","39.097603"],
          // center: ["117.122824","39.097117"],
          zoom: "19"
        },
        markerCenter: ["117.122210","39.097603"],
        mapLabel: {
          content: ''
        },
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
      }
    },
    computed: {
      lang(){
        return this.languageDefault == 'zh_cn' ? 'zh_cn' : 'en'
      }
    },
    created () {

    },
    methods: {


    },
  }
</script>

<style>

</style>
